'use client';

import { forwardRef, useContext, useEffect } from 'react';

import { css, cx } from '@/styled-system/css';

import { InputChipContext } from './context/input-chip.context';
import { inputChipLabelStyles } from './styles/input-chip-label.styles';
import type { InputChipLabelPropsInterface } from './types/input-chip-label.types';

/**
 * @since 10.0.0
 */
export const InputChipLabel = forwardRef<HTMLSpanElement, InputChipLabelPropsInterface>(
  (props, forwardedRef) => {
    const { children, className, css: cssProp, truncate = true, ...rest } = props;

    const styles = css({ truncate }, inputChipLabelStyles, cssProp);

    // Use label text as close button's `title`
    const { labelText, setLabelText } = useContext(InputChipContext);
    useEffect(() => {
      if (!labelText) {
        setLabelText(children);
      }
    }, [children, labelText, setLabelText]);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="InputChip.Label"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </span>
    );
  },
);

InputChipLabel.displayName = 'InputChip.Label';
